import { Component, OnInit } from '@angular/core';
import { IAddExistingCardForm } from '../../forms/add-existing-card-form/add-existing-card-form.component';
import { AccountService, IApiAccount } from '../../services/account.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { finalize } from 'rxjs/operators';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-add-existing-card-modal',
    templateUrl: './add-existing-card-modal.component.html',
    styleUrls: ['./add-existing-card-modal.component.scss'],
    standalone: false
})
export class AddExistingCardModalComponent implements OnInit {
  title: string = 'Account.AddExistingCard';

  constructor(private account: AccountService,
              private loader: LoaderService,
              private modalCtrl: ModalController) { }

  ngOnInit() {}

  async onFormSubmitted(form: IAddExistingCardForm) {
    const loader = await this.loader.create();
    await loader.present();
    this.account.addExistingCard(form.card, form.cvc)
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe((model: IApiAccount) => {
        this.modalCtrl.dismiss(model);
      });
  }

  cancel() {
    this.modalCtrl.dismiss(null);
  }
}
